import { settings } from "./settings";

export const entity_language = {
    entity: {
        user: 'Utenti',
        user_group: 'Gruppi',
        user_entity_saved_filters: 'Filtri salvati',
        user_entity_preferences: 'Preferenze entità',
        customer: 'Clienti',
        customer_contacts: 'Contatti clienti',
        supplier_contacts: 'Contatti fornitori',
        supplier: 'Fornitori',
        sales_agent: 'Segnalatori',
        customer_payment_condition: 'Condizioni di pagamento Cliente',
        supplier_payment_condition: 'Condizioni di pagamento Fornitore',
        customer_offer_row: 'Riga preventivo cliente',
        customer_order_row: 'Riga ordine cliente',
        supplier_order_row: 'Riga ordine fornitore',
        item_model_category: 'Categorie',
        customer_order: 'Ordini cliente',
        customer_order_payment: 'Storico pagamenti',
        gyv_customer_order: 'Ordini cliente',
        gyv_customer_order_delivery: 'Consegne',
        supplier_order: 'Ordini fornitore',
        gyv_supplier_order: 'Ordini fornitore',
        customer_offer: 'Preventivi',
        gyv_customer_offer: 'Preventivi',
        activity: 'Attività',
        delivery: 'Consegne',
        transport_document_reason: 'Causali DDT',
        item_model_movement: 'Storico movimentazioni',
        log: 'Log di sistema',
        category: 'Categorie',
        warehouse: 'Magazzini',
        location: 'Locazioni',
        notification: 'Notifiche',
        gyv_customer_order_rows_open: 'Righe aperte ordini cliente',
        customer_order_delivery: 'Consegne',
        invoice: 'Fatture',
        gyv_invoice: 'Fatture',
        invoice_row: 'Righe fatture',
        customer_order_installment: 'Castelletto pagamenti',
        method_payment: 'Modalità di pagamento',
        vat_condition: 'Condizioni IVA',
    },
    labels: {
        "user": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idUserGroup": 'Gruppo',
            "name": 'Nome',
            "surname": 'Cognome',
            "username": 'Username',
            "phone": 'Telefono',
            "email": 'Email',
            "level": 'Livello utente',
            "level.options.0": 'Super Amministratore',
            "level.options.1": 'Amministratore',
            "level.options.2": 'Montatore',
            "level.options.3": 'Venditore',
            "avatar": 'Avatar',
            "password": 'Password',
            "percentage": 'Provvigione [%]',
            "color": 'Colore',
            "role": 'Titolo',
            "sede": 'Sede',
            "visible": 'Visibile',
        },
        "user_group": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Nome gruppo',
        },
        "user_entity_saved_filters": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "author": 'Utente',
            "entity": 'Entità',
            "name": 'Nome',
            "notes": 'Note',
            "content": 'Json filtri'
        },
        "user_entity_preferences": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "author": 'Utente',
            "entity": 'Entità',
            "content": 'Json preferenze'
        },
        "customer": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Cognome Nome / Rag. Sociale',
            "category": 'Tipo cliente fiscale',
            "category.options.0": 'Privato',
            "category.options.1": 'Società di capitali',
            "category.options.2": 'Società di persone',
            "code": 'Codice identificativo',
            "address": 'Indirizzo',
            "route": 'Via',
            "city": 'Città',
            "country": 'Stato',
            "province": 'Provincia',
            "region": 'Regione',
            "postalCode": 'Codice postale',
            "streetNumber": 'Numero civico',
            "latitude": 'Latitudine',
            "longitude": 'Longitude',
            "email": 'Email',
            "phone": 'Telefono',
            "idVatCondition": 'Condizione IVA',
            "stateVatNumber": 'Stato P.iva',
            "stateVatNumber.options.IT": "IT",
            "stateVatNumber.options.AF": "AF",
            "stateVatNumber.options.AX": "AX",
            "stateVatNumber.options.AL": "AL",
            "stateVatNumber.options.DZ": "DZ",
            "stateVatNumber.options.AS": "AS",
            "stateVatNumber.options.AD": "AD",
            "stateVatNumber.options.AO": "AO",
            "stateVatNumber.options.AI": "AI",
            "stateVatNumber.options.AQ": "AQ",
            "stateVatNumber.options.AG": "AG",
            "stateVatNumber.options.AR": "AR",
            "stateVatNumber.options.AM": "AM",
            "stateVatNumber.options.AW": "AW",
            "stateVatNumber.options.AU": "AU",
            "stateVatNumber.options.AT": "AT",
            "stateVatNumber.options.AZ": "AZ",
            "stateVatNumber.options.BS": "BS",
            "stateVatNumber.options.BH": "BH",
            "stateVatNumber.options.BD": "BD",
            "stateVatNumber.options.BB": "BB",
            "stateVatNumber.options.BY": "BY",
            "stateVatNumber.options.BE": "BE",
            "stateVatNumber.options.BZ": "BZ",
            "stateVatNumber.options.BJ": "BJ",
            "stateVatNumber.options.BM": "BM",
            "stateVatNumber.options.BT": "BT",
            "stateVatNumber.options.BO": "BO",
            "stateVatNumber.options.BQ": "BQ",
            "stateVatNumber.options.BA": "BA",
            "stateVatNumber.options.BW": "BW",
            "stateVatNumber.options.BV": "BV",
            "stateVatNumber.options.BR": "BR",
            "stateVatNumber.options.IO": "IO",
            "stateVatNumber.options.BN": "BN",
            "stateVatNumber.options.BG": "BG",
            "stateVatNumber.options.BF": "BF",
            "stateVatNumber.options.BI": "BI",
            "stateVatNumber.options.KH": "KH",
            "stateVatNumber.options.CM": "CM",
            "stateVatNumber.options.CA": "CA",
            "stateVatNumber.options.CV": "CV",
            "stateVatNumber.options.KY": "KY",
            "stateVatNumber.options.CF": "CF",
            "stateVatNumber.options.TD": "TD",
            "stateVatNumber.options.CL": "CL",
            "stateVatNumber.options.CN": "CN",
            "stateVatNumber.options.CX": "CX",
            "stateVatNumber.options.CC": "CC",
            "stateVatNumber.options.CO": "CO",
            "stateVatNumber.options.KM": "KM",
            "stateVatNumber.options.CG": "CG",
            "stateVatNumber.options.CD": "CD",
            "stateVatNumber.options.CK": "CK",
            "stateVatNumber.options.CR": "CR",
            "stateVatNumber.options.CI": "CI",
            "stateVatNumber.options.HR": "HR",
            "stateVatNumber.options.CU": "CU",
            "stateVatNumber.options.CW": "CW",
            "stateVatNumber.options.CY": "CY",
            "stateVatNumber.options.CZ": "CZ",
            "stateVatNumber.options.DK": "DK",
            "stateVatNumber.options.DJ": "DJ",
            "stateVatNumber.options.DM": "DM",
            "stateVatNumber.options.DO": "DO",
            "stateVatNumber.options.EC": "EC",
            "stateVatNumber.options.EG": "EG",
            "stateVatNumber.options.SV": "SV",
            "stateVatNumber.options.GQ": "GQ",
            "stateVatNumber.options.ER": "ER",
            "stateVatNumber.options.EE": "EE",
            "stateVatNumber.options.ET": "ET",
            "stateVatNumber.options.FK": "FK",
            "stateVatNumber.options.FO": "FO",
            "stateVatNumber.options.FJ": "FJ",
            "stateVatNumber.options.FI": "FI",
            "stateVatNumber.options.FR": "FR",
            "stateVatNumber.options.GF": "GF",
            "stateVatNumber.options.PF": "PF",
            "stateVatNumber.options.TF": "TF",
            "stateVatNumber.options.GA": "GA",
            "stateVatNumber.options.GM": "GM",
            "stateVatNumber.options.GE": "GE",
            "stateVatNumber.options.DE": "DE",
            "stateVatNumber.options.GH": "GH",
            "stateVatNumber.options.GI": "GI",
            "stateVatNumber.options.GR": "GR",
            "stateVatNumber.options.GL": "GL",
            "stateVatNumber.options.GD": "GD",
            "stateVatNumber.options.GP": "GP",
            "stateVatNumber.options.GU": "GU",
            "stateVatNumber.options.GT": "GT",
            "stateVatNumber.options.GG": "GG",
            "stateVatNumber.options.GN": "GN",
            "stateVatNumber.options.GW": "GW",
            "stateVatNumber.options.GY": "GY",
            "stateVatNumber.options.HT": "HT",
            "stateVatNumber.options.HM": "HM",
            "stateVatNumber.options.VA": "VA",
            "stateVatNumber.options.HN": "HN",
            "stateVatNumber.options.HK": "HK",
            "stateVatNumber.options.HU": "HU",
            "stateVatNumber.options.IS": "IS",
            "stateVatNumber.options.IN": "IN",
            "stateVatNumber.options.ID": "ID",
            "stateVatNumber.options.IR": "IR",
            "stateVatNumber.options.IQ": "IQ",
            "stateVatNumber.options.IE": "IE",
            "stateVatNumber.options.IM": "IM",
            "stateVatNumber.options.IL": "IL",
            "stateVatNumber.options.JM": "JM",
            "stateVatNumber.options.JP": "JP",
            "stateVatNumber.options.JE": "JE",
            "stateVatNumber.options.JO": "JO",
            "stateVatNumber.options.KZ": "KZ",
            "stateVatNumber.options.KE": "KE",
            "stateVatNumber.options.KI": "KI",
            "stateVatNumber.options.KP": "KP",
            "stateVatNumber.options.KR": "KR",
            "stateVatNumber.options.KW": "KW",
            "stateVatNumber.options.KG": "KG",
            "stateVatNumber.options.LA": "LA",
            "stateVatNumber.options.LV": "LV",
            "stateVatNumber.options.LB": "LB",
            "stateVatNumber.options.LS": "LS",
            "stateVatNumber.options.LR": "LR",
            "stateVatNumber.options.LY": "LY",
            "stateVatNumber.options.LI": "LI",
            "stateVatNumber.options.LT": "LT",
            "stateVatNumber.options.LU": "LU",
            "stateVatNumber.options.MO": "MO",
            "stateVatNumber.options.MK": "MK",
            "stateVatNumber.options.MG": "MG",
            "stateVatNumber.options.MW": "MW",
            "stateVatNumber.options.MY": "MY",
            "stateVatNumber.options.MV": "MV",
            "stateVatNumber.options.ML": "ML",
            "stateVatNumber.options.MT": "MT",
            "stateVatNumber.options.MH": "MH",
            "stateVatNumber.options.MQ": "MQ",
            "stateVatNumber.options.MR": "MR",
            "stateVatNumber.options.MU": "MU",
            "stateVatNumber.options.YT": "YT",
            "stateVatNumber.options.MX": "MX",
            "stateVatNumber.options.FM": "FM",
            "stateVatNumber.options.MD": "MD",
            "stateVatNumber.options.MC": "MC",
            "stateVatNumber.options.MN": "MN",
            "stateVatNumber.options.ME": "ME",
            "stateVatNumber.options.MS": "MS",
            "stateVatNumber.options.MA": "MA",
            "stateVatNumber.options.MZ": "MZ",
            "stateVatNumber.options.MM": "MM",
            "stateVatNumber.options.NA": "NA",
            "stateVatNumber.options.NR": "NR",
            "stateVatNumber.options.NP": "NP",
            "stateVatNumber.options.NL": "NL",
            "stateVatNumber.options.NC": "NC",
            "stateVatNumber.options.NZ": "NZ",
            "stateVatNumber.options.NI": "NI",
            "stateVatNumber.options.NE": "NE",
            "stateVatNumber.options.NG": "NG",
            "stateVatNumber.options.NU": "NU",
            "stateVatNumber.options.NF": "NF",
            "stateVatNumber.options.MP": "MP",
            "stateVatNumber.options.NO": "NO",
            "stateVatNumber.options.OM": "OM",
            "stateVatNumber.options.PK": "PK",
            "stateVatNumber.options.PW": "PW",
            "stateVatNumber.options.PS": "PS",
            "stateVatNumber.options.PA": "PA",
            "stateVatNumber.options.PG": "PG",
            "stateVatNumber.options.PY": "PY",
            "stateVatNumber.options.PE": "PE",
            "stateVatNumber.options.PH": "PH",
            "stateVatNumber.options.PN": "PN",
            "stateVatNumber.options.PL": "PL",
            "stateVatNumber.options.PT": "PT",
            "stateVatNumber.options.PR": "PR",
            "stateVatNumber.options.QA": "QA",
            "stateVatNumber.options.RE": "RE",
            "stateVatNumber.options.RO": "RO",
            "stateVatNumber.options.RU": "RU",
            "stateVatNumber.options.RW": "RW",
            "stateVatNumber.options.BL": "BL",
            "stateVatNumber.options.SH": "SH",
            "stateVatNumber.options.KN": "KN",
            "stateVatNumber.options.LC": "LC",
            "stateVatNumber.options.MF": "MF",
            "stateVatNumber.options.PM": "PM",
            "stateVatNumber.options.VC": "VC",
            "stateVatNumber.options.WS": "WS",
            "stateVatNumber.options.SM": "SM",
            "stateVatNumber.options.ST": "ST",
            "stateVatNumber.options.SA": "SA",
            "stateVatNumber.options.SN": "SN",
            "stateVatNumber.options.RS": "RS",
            "stateVatNumber.options.SC": "SC",
            "stateVatNumber.options.SL": "SL",
            "stateVatNumber.options.SG": "SG",
            "stateVatNumber.options.SX": "SX",
            "stateVatNumber.options.SK": "SK",
            "stateVatNumber.options.SI": "SI",
            "stateVatNumber.options.SB": "SB",
            "stateVatNumber.options.SO": "SO",
            "stateVatNumber.options.ZA": "ZA",
            "stateVatNumber.options.GS": "GS",
            "stateVatNumber.options.SS": "SS",
            "stateVatNumber.options.ES": "ES",
            "stateVatNumber.options.LK": "LK",
            "stateVatNumber.options.SD": "SD",
            "stateVatNumber.options.SR": "SR",
            "stateVatNumber.options.SJ": "SJ",
            "stateVatNumber.options.SZ": "SZ",
            "stateVatNumber.options.SE": "SE",
            "stateVatNumber.options.CH": "CH",
            "stateVatNumber.options.SY": "SY",
            "stateVatNumber.options.TW": "TW",
            "stateVatNumber.options.TJ": "TJ",
            "stateVatNumber.options.TZ": "TZ",
            "stateVatNumber.options.TH": "TH",
            "stateVatNumber.options.TL": "TL",
            "stateVatNumber.options.TG": "TG",
            "stateVatNumber.options.TK": "TK",
            "stateVatNumber.options.TO": "TO",
            "stateVatNumber.options.TT": "TT",
            "stateVatNumber.options.TN": "TN",
            "stateVatNumber.options.TR": "TR",
            "stateVatNumber.options.TM": "TM",
            "stateVatNumber.options.TC": "TC",
            "stateVatNumber.options.TV": "TV",
            "stateVatNumber.options.UG": "UG",
            "stateVatNumber.options.UA": "UA",
            "stateVatNumber.options.AE": "AE",
            "stateVatNumber.options.GB": "GB",
            "stateVatNumber.options.US": "US",
            "stateVatNumber.options.UM": "UM",
            "stateVatNumber.options.UY": "UY",
            "stateVatNumber.options.UZ": "UZ",
            "stateVatNumber.options.VU": "VU",
            "stateVatNumber.options.VE": "VE",
            "stateVatNumber.options.VN": "VN",
            "stateVatNumber.options.VG": "VG",
            "stateVatNumber.options.VI": "VI",
            "stateVatNumber.options.WF": "WF",
            "stateVatNumber.options.EH": "EH",
            "stateVatNumber.options.YE": "YE",
            "stateVatNumber.options.ZM": "ZM",
            "stateVatNumber.options.ZW": "ZW",
            "stateVatNumber.options.XK": "XK",
            "stateVatNumber.options.XI": "XI",
            "stateVatNumber.options.OO": "OO",
            "stateVatNumber.options.EL": "EL",
            "vatNumber": 'P.iva',
            "taxCode": 'Codice fiscale',
            "paymentNotes": 'Note pagamento',
            "type": 'Tipo',
            "type.options.0_POTENTIAL": 'Potenziale',
            "type.options.10_CONVERTED": 'Convertito',
            "notes": 'Note',
            "idPaymentCondition": 'Condizione di pagamento',
            "vat": 'Condizione iva',
            "contacts": 'Contatti',
            "locality": 'Città',
            "sdi": 'Codice SDI',
            "pec": 'PEC'
        },
        "customer_contacts": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idCustomer": 'Cliente',
            "name": 'Cognome e Nome',
            "role": 'Ruolo',
            "phone": 'Telefono',
            "email": 'Email',
            "notes": 'Note'
        },
        "supplier": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Ragione Sociale',
            "address": 'Indirizzo',
            "city": 'Città',
            "province": 'Provincia',
            "state": 'Nazione',
            "postalCode": 'Codice postale',
            "email": 'Email',
            "phone": 'Telefono',
            "vatNumber": 'P.iva',
            "taxCode": 'Codice fiscale',
            "commercial_discount": 'Sconto commerciale',
            "cash_flow_discount": 'Sconto cassa',
            "sale_discount": 'Sconto di vendita',
            "paymentNotes": 'Note pagamento',
            "notes": 'Note',
            "idPaymentCondition": 'Condizione di pagamento',
            "contacts": 'Contatti',
            "deliveryTime": 'Tempo di consegna standard [giorni]'
        },
        "gyv_supplier_no_discount": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Ragione Sociale',
            "address": 'Indirizzo',
            "city": 'Città',
            "province": 'Provincia',
            "state": 'Nazione',
            "postalCode": 'Codice postale',
            "email": 'Email',
            "phone": 'Telefono',
            "vatNumber": 'P.iva',
            "taxCode": 'Codice fiscale',
            "commercial_discount": 'Sconto commerciale',
            "cash_flow_discount": 'Sconto cassa',
            "sale_discount": 'Sconto di vendita',
            "paymentNotes": 'Note pagamento',
            "notes": 'Note',
            "idPaymentCondition": 'Condizione di pagamento',
            "contacts": 'Contatti',
            "deliveryTime": 'Tempo di consegna standard [giorni]'
        },
        "supplier_contacts": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idSupplier": 'Fornitore',
            "name": 'Cognome e Nome',
            "role": 'Ruolo',
            "phone": 'Telefono',
            "email": 'Email',
            "notes": 'Note'
        },
        "sales_agent": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Cognome e Nome',
            "phone": 'Telefono',
            "email": 'Email',
            "percentage": 'Provvigione [%]'
        },
        "customer_payment_condition": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Nome',
            "print": 'Stampa',
            "notes": 'Note'
        },
        "supplier_payment_condition": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Nome',
            "notes": 'Note'
        },
        "customer_offer": {
            "id": 'id',
            "date": 'Data creazione',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "author": 'Venditore',
            "idCustomer": 'Cliente',
            "customer": 'Nome cliente',
            "internalCode": 'Codice interno',
            "riferimento": 'Riferimento',
            "file": 'Allegato',
            "floor": 'Piano edificio',
            "elevator": 'Ascensore',
            "parking": 'Parcheggio',
            "ladder_truck": 'Autoscala',
            "hoist_elevator": 'Montacarichi',
            "parquet": 'Smaltimento',
            "pedestrian_zone": 'Zona pedonale',
            "no_traffic_zone": 'ZTL',
            "building": 'Edificio',
            "zone": 'Zona',
            "deliveryDate": 'Data consegna prevista',
            "vat": 'IVA',
            "idVatCondition": 'Condizione IVA',
            "idPaymentCondition": 'Condizione di pagamento',
            "notes": 'Note',
            "rows": 'Righe',
            "status": 'Stato',
            "status.options.0_PENDING": 'In attesa',
            "status.options.5_PRESALE": 'Prevendita',
            "status.options.10_CONFIRMED": 'Accettato',
            "status.options.20_DECLINED": 'Rifiutato',
            "status.options.": 'In attesa',
            "discount": 'Sconto offerta [%]',
            "increase": 'Maggiorazione [%]',
            "transportAndAssembly": 'Trasporto e montaggio',
            "transportAndAssembly.options.0_INCLUDED": 'Incluso',
            "transportAndAssembly.options.10_EXCLUDING": 'Escluso',
            "transportCost": 'Spese di trasporto (iva inclusa)',
            "methodPayment": 'Metodo di pagamento',
            "bank": 'Banca',
            "iban": 'IBAN',
            "files": 'File',
            "deliveryAddress": 'Indirizzo di consegna',
            "locality": 'Città',
            "totalListPrice": 'Totale listino',
            "totalDiscount": 'Totale sconti',
            "totalRows": 'Totale righe (iva ' + settings.iva_label + ')',
            "totalVat": 'Totale IVA righe',
            "totalPrice": 'Totale preventivo (iva inclusa)',
            "documentType": 'Documento fiscale',
            "documentType.options.0_RECEIPT": 'Scontrino',
            "documentType.options.10_INVOICE": 'Fattura',
        },
        "customer_offer_files": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Nome file',
            "notes": 'Note',
            "file": 'File'
        },
        "customer_offer_row": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "code": 'Codice',
            "name": 'Articolo',
            "description": 'Descrizione',
            "idCategory": 'Categoria',
            "idSupplier": 'Fornitore',
            "quantity": 'Quantità',
            "price": 'Totale riga (iva ' + settings.iva_label + ')',
            "listPrice": 'Prezzo listino unitario',
            "discount": 'Sconto €',
            "discountPercentage": 'Sconto %',
            "discountOffer": 'Sconto testata %',
            "notes": 'Note interne',
            "vat": 'IVA',
            "vatPrice": 'Totale IVA riga',
            "totalPrice": 'Totale riga IVA inclusa',
        },
        "customer_order": {
            "id": 'id',
            "date": 'Data creazione',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "author": 'Venditore',
            "idCustomerOffer": 'ID Preventivo',
            "idCustomer": 'Cliente',
            "internalCode": 'Codice interno',
            "riferimento": 'Riferimento',
            "deliveryDate": 'Data consegna prevista',
            "realDeliveryDate": 'Data consegna effettiva',
            "finishDeliveryDate": 'Data fine consegna effettiva',
            "deliveryNotes": 'Note di consegna',
            "idUserDelivery": 'Montatore',
            "file": 'Allegato',
            "floor": 'Piano edificio',
            "elevator": 'Ascensore',
            "parking": 'Parcheggio',
            "ladder_truck": 'Autoscala',
            "hoist_elevator": 'Montacarichi',
            "parquet": 'Smaltimento',
            "pedestrian_zone": 'Zona pedonale',
            "no_traffic_zone": 'ZTL',
            "building": 'Edificio',
            "zone": 'Zona',
            "vat": 'IVA',
            "idVatCondition": 'Condizione IVA',
            "idPaymentCondition": 'Condizione di pagamento',
            "notes": 'Note',
            "rows": 'Righe',
            "type": 'Tipo',
            "type.options.0_BUY": 'Acquisto',
            "type.options.10_REPLACEMENT": 'Sostituzione',
            "status": 'Stato',
            "status.options.0_PENDING": 'Da processare',
            "status.options.1_ORDERED": 'Ordinato a fornitore',
            "status.options.7_READY_FOR_DELIVERY": 'Pronto per la consegna',
            "status.options.10_COMPLETED": 'Consegnato',
            "status.options.15_PARTIAL_DELIVERED": 'Consegnato parzialmente',
            "status.options.20_CANCELED": 'Annullato',
            "discount": 'Sconto ordine [%]',
            "increase": 'Maggiorazione [%]',
            "transportCost": 'Spese di trasporto (iva inclusa)',
            "transportAndAssembly": 'Trasporto e montaggio',
            "transportAndAssembly.options.0_INCLUDED": 'Incluso',
            "transportAndAssembly.options.10_EXCLUDING": 'Escluso',
            "transportAndAssembly": 'Trasporto e montaggio',
            "methodPayment": 'Metodo di pagamento',
            "bank": 'Banca',
            "iban": 'IBAN',
            "shippingDate": 'Data spedizone',
            "files": 'File',
            "installment": 'Casteletto pagamenti',
            "supplier_orders": 'Ordini fornitore effettuati',
            "deliveryAddress": 'Indirizzo di consegna',
            "latitude": 'Latitudine',
            "longitude": 'Longitude',
            "locality": 'Città',
            "totalListPrice": 'Totale listino',
            "totalDiscount": 'Totale sconti',
            "totalRows": 'Totale righe (iva ' + settings.iva_label + ')',
            "totalVat": 'Totale IVA righe',
            "totalPrice": 'Totale ordine (iva inclusa)',
            "documentType": 'Documento fiscale',
            "documentType.options.0_RECEIPT": 'Scontrino',
            "documentType.options.10_INVOICE": 'Fattura',
        },
        "customer_order_files": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Nome file',
            "notes": 'Note',
            "file": 'File'
        },
        "customer_order_row": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "code": 'Codice',
            "name": 'Articolo',
            "description": 'Descrizione',
            "idCategory": 'Categoria',
            "idSupplier": 'Fornitore',
            "quantity": 'Quantità',
            "price": 'Prezzo di vendita (iva ' + settings.iva_label + ')',
            "listPrice": 'Prezzo listino unitario',
            "discount": 'Sconto €',
            "discountOrder": 'Sconto testata %',
            "discountPercentage": 'Sconto %',
            "notes": 'Note interne',
            "vat": 'IVA',
            "vatPrice": 'Costo IVA',
            "idLocation": 'Locazione',
            "status": 'Stato',
            "status.options.0_PENDING": 'In attesa',
            "status.options.5_ORDERED": 'Ordinata',
            "status.options.10_RECEIVED": 'Ricevuto',
            "status.options.15_IN_DELIVERY": 'In consegna',
            "status.options.20_DELIVERED": 'Consegnato',
            "totalPrice": 'Totale riga IVA inclusa',
        },
        "supplier_order": {
            "id": 'id',
            "date": 'Data creazione',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idSupplier": 'Fornitore',
            "author": 'Venditore',
            "idCustomerOrder": 'Riferimento ordine cliente',
            "customerName": 'Nome cliente',
            "internalCode": 'Riferimento',
            "status": 'Stato',
            "status.options.0_PENDING": 'In attesa',
            "status.options.1_TO_SEND": 'Da inviare',
            "status.options.2_SENT": 'Inviato',
            "status.options.5_PARTIAL": 'Ricevuto parzialmente',
            "status.options.10_COMPLETED": 'Ricevuto correttamente',
            "status.options.20_CANCELED": 'Annullato',
            "idPaymentCondition": 'Condizione di pagamento',
            "paymentNotes": 'Note di pagamento',
            "files": 'Conferma ordine',
            "confirmedDeliveryDate": 'Data consegna confermata',
            "notes": 'Note',
            "rows": 'Righe',
            "requestedDeliveryDate": 'Data consegna richiesta',
            "weekNumber": 'Settimana',
            "listPriceOrder": 'Prezzo'
        },
        "supplier_order_files": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Numero conferma ordine',
            "notes": 'Note',
            "file": 'File',
            "cost": 'Costo',
        },
        "supplier_order_row": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Articolo',
            "description": 'Descrizione',
            "idCategory": 'Categoria',
            "idSupplier": 'Fornitore',
            "quantity": 'Quantità',
            "listPriceOrder": 'Prezzo acquisto',
            "notes": 'Note interne',
            "idCustomerOrderRow": 'Riga ordine cliente',
            "status": 'Stato',
            "status.options.0_PENDING": 'Da ricevere',
            "status.options.2_ARRIVED": 'Ricevuto',
        },
        "activity": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "author": 'Utente',
            "idCustomer": 'Cliente',
            "title": 'Titolo',
            "notes": 'Note',
            "type": 'Tipo attività',
            "type.options.0_PHONE": 'Telefonata',
            "type.options.10_EMAIL": 'Email',
            "type.options.20_MEET": 'Incontro',
            "status": 'Stato',
            "status.options.0_TODO": 'Da fare',
            "status.options.10_INPROGRESS": 'In corso',
            "status.options.20_DONE": 'Completata',
            "plannedDate": 'Data inizio attività',
            "plannedDateEnd": 'Data fine attività',
            "idCustomerOrder": 'Codice interno ordine',
            "idCustomerOffer": 'Codice interno preventivo',
            "idGoogleCalendar": 'ID Google Calendar',
        },
        "delivery": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idUser": 'Montatore',
            "idCustomerOrder": 'Ordine cliente',
            "notes": 'Note',
            "status": 'Stato',
            "status.options.0_TODO": 'Da fare',
            "status.options.10_DONE": 'Completata',
            "plannedDate": 'Data consegna'
        },
        "category": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Nome',
            "description": 'Template descrizione',
            "idItemModelCategory": 'Categoria padre'
        },
        "transport_document_reason": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Nome',
            "notes": 'Note'
        },
        "log": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idItem": 'Id elemento',
            "idUser": 'Utente',
            "entity": 'Entità',
            "operation": 'Operazione',
            "operation.options.0_DELETE": 'Elimina',
            "operation.options.1_EDIT": 'Modifica',
            "operation.options.2_ADD": 'Aggiungi',
            "operation.options.3_LOGIN": 'Login',
            "operation.options.4_LOGOUT": 'Logout',
            "notes": 'Note',
        },
        "gyv_customer_offer": {
            "id": 'id',
            "date": 'Data creazione',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "author": 'Venditore',
            "authorName": 'Venditore',
            "idCustomer": 'Cliente',
            "customer": 'Nome cliente',
            "internalCode": 'Codice interno',
            "riferimento": 'Riferimento',
            "file": 'Allegato',
            "floor": 'Piano edificio',
            "elevator": 'Ascensore',
            "parking": 'Parcheggio',
            "ladder_truck": 'Autoscala',
            "hoist_elevator": 'Montacarichi',
            "parquet": 'Smaltimento',
            "pedestrian_zone": 'Zona pedonale',
            "no_traffic_zone": 'ZTL',
            "building": 'Edificio',
            "zone": 'Zona',
            "deliveryDate": 'Data consegna prevista',
            "vat": 'IVA',
            "idPaymentCondition": 'Condizione di pagamento',
            "notes": 'Note',
            "rows": 'Righe',
            "status": 'Stato',
            "status.options.0_PENDING": 'In attesa',
            "status.options.5_PRESALE": 'Prevendita',
            "status.options.10_CONFIRMED": 'Accettato',
            "status.options.20_DECLINED": 'Rifiutato',
            "status.options.": 'In attesa',
            "discount": 'Sconto offerta [%]',
            "increase": 'Maggiorazione [%]',
            "transportAndAssembly": 'Trasporto e montaggio',
            "transportAndAssembly.options.0_INCLUDED": 'Incluso',
            "transportAndAssembly.options.10_EXCLUDING": 'Escluso',
            "transportCost": 'Spese di trasporto (iva inclusa)',
            "methodPayment": 'Metodo di pagamento',
            "bank": 'Banca',
            "iban": 'IBAN',
            "files": 'File',
            "deliveryAddress": 'Indirizzo di consegna',
            "locality": 'Città',
            "totalListPrice": 'Totale listino',
            "totalDiscount": 'Totale sconti',
            "totalRows": 'Totale righe (iva ' + settings.iva_label + ')',
            "totalVat": 'Totale IVA righe',
            "totalPrice": 'Totale preventivo (iva inclusa)',
            "documentType": 'Documento fiscale',
            "documentType.options.0_RECEIPT": 'Scontrino',
            "documentType.options.10_INVOICE": 'Fattura',
        },
        "gyv_customer_order": {
            "id": 'id',
            "date": 'Data creazione',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "author": 'ID Venditore',
            "authorName": 'Venditore',
            "idCustomerOffer": 'ID Preventivo',
            "idCustomer": 'ID Cliente',
            "customer": 'Cliente',
            "internalCode": 'Codice interno',
            "riferimento": 'Riferimento',
            "deliveryDate": 'Data consegna prevista',
            "realDeliveryDate": 'Data consegna effettiva',
            "finishDeliveryDate": 'Data fine consegna effettiva',
            "deliveryNotes": 'Note di consegna',
            "idUserDelivery": 'Montatore',
            "file": 'Allegato',
            "floor": 'Piano edificio',
            "elevator": 'Ascensore',
            "parking": 'Parcheggio',
            "ladder_truck": 'Autoscala',
            "hoist_elevator": 'Montacarichi',
            "parquet": 'Smaltimento',
            "pedestrian_zone": 'Zona pedonale',
            "no_traffic_zone": 'ZTL',
            "building": 'Edificio',
            "zone": 'Zona',
            "vat": 'IVA',
            "idPaymentCondition": 'Condizione di pagamento',
            "notes": 'Note',
            "rows": 'Righe',
            "type": 'Tipo',
            "type.options.0_BUY": 'Acquisto',
            "type.options.10_REPLACEMENT": 'Sostituzione',
            "status": 'Stato',
            "status.options.0_PENDING": 'Da processare',
            "status.options.1_ORDERED": 'Ordinato a fornitore',
            "status.options.7_READY_FOR_DELIVERY": 'Pronto per la consegna',
            "status.options.10_COMPLETED": 'Consegnato',
            "status.options.15_PARTIAL_DELIVERED": 'Consegnato parzialmente',
            "status.options.20_CANCELED": 'Annullato',
            "discount": 'Sconto ordine [%]',
            "increase": 'Maggiorazione [%]',
            "transportCost": 'Spese di trasporto (iva inclusa)',
            "transportAndAssembly": 'Trasporto e montaggio',
            "transportAndAssembly.options.0_INCLUDED": 'Incluso',
            "transportAndAssembly.options.10_EXCLUDING": 'Escluso',
            "transportAndAssembly": 'Trasporto e montaggio',
            "methodPayment": 'Metodo di pagamento',
            "bank": 'Banca',
            "iban": 'IBAN',
            "shippingDate": 'Data spedizone',
            "files": 'File',
            "supplier_orders": 'Ordini fornitore effettuati',
            "deliveryAddress": 'Indirizzo di consegna',
            "latitude": 'Latitudine',
            "longitude": 'Longitude',
            "locality": 'Città',
            "totalListPrice": 'Totale listino',
            "totalDiscount": 'Totale sconti',
            "totalRows": 'Totale righe (iva ' + settings.iva_label + ')',
            "totalVat": 'Totale IVA righe',
            "totalPrice": 'Totale ordine (iva inclusa)',
            "documentType": 'Documento fiscale',
            "documentType.options.0_RECEIPT": 'Scontrino',
            "documentType.options.10_INVOICE": 'Fattura',
            "paymentStatus": 'Stato pagamenti',
            "paymentStatus.options.0": 'Da pagare',
            "paymentStatus.options.1": 'Pagato parzialmente',
            "paymentStatus.options.2": 'Pagato',
            "late": 'Stato consegna',
            "late.options.NO": 'In orario',
            "late.options.SI": 'In ritardo',
            "deliveryAvaiable": 'Consegna disponibile',
            "righe_ricevute": 'Righe ricevute',
        },
        "gyv_supplier_order": {
            "id": 'id',
            "date": 'Data creazione',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idSupplier": 'ID Fornitore',
            "author": 'ID Venditore',
            "idCustomerOrder": 'Riferimento ordine cliente',
            "customerName": 'Nome cliente',
            "internalCode": 'Riferimento',
            "status": 'Stato',
            "status.options.0_PENDING": 'Da inviare',
            "status.options.1_TO_SEND": 'Da inviare',
            "status.options.2_SENT": 'Inviato',
            "status.options.5_PARTIAL": 'Ricevuto parzialmente',
            "status.options.10_COMPLETED": 'Ricevuto correttamente',
            "status.options.20_CANCELED": 'Annullato',
            "idPaymentCondition": 'Condizione di pagamento',
            "paymentNotes": 'Note di pagamento',
            "files": 'Conferma ordine',
            "confirmedDeliveryDate": 'Data consegna confermata',
            "notes": 'Note',
            "rows": 'Righe',
            "requestedDeliveryDate": 'Data consegna richiesta',
            "weekNumber": 'Settimana',
            "authorName": 'Venditore',
            "supplier": 'Fornitore',
            "internalCustomerOrder": 'Codice ordine cliente',
            "late": 'Stato consegna',
            "late.options.NO": 'In orario',
            "late.options.SI": 'In ritardo'
        },
        "gyv_customer_order_rows_open": {
            "id": 'id',
            "date": 'Data creazione',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Articolo',
            "description": 'Descrizione',
            "category": 'Categoria',
            "supplier": 'Fornitore',
            "quantity": 'Quantità',
            "listPrice": 'Prezzo',
            "customer": 'Cliente',
            "dateOrder": 'Data ordine',
            "idOrder": 'ID ordine',
            "internalCode": 'Codice interno',
            "status": 'Stato ordine',
            "status.options.0_PENDING": 'Da processare',
            "status.options.1_ORDERED": 'Ordinato a fornitore',
            "status.options.7_READY_FOR_DELIVERY": 'Pronto per la consegna',
            "status.options.15_IN_DELIVERY": 'In consegna',
            "status.options.10_COMPLETED": 'Consegnato',
            "status.options.20_CANCELED": 'Annullato',
            "author": 'Venditore'
        },
        "notification": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "notificationAll": 'Notifiche attive',
            "notificationOrder": 'Notifiche ordini',
            "notificationOffer": 'Notifiche preventivi',
            "idUser": 'Utente'
        },
        "customer_order_payment": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "author": 'Utente',
            "idCustomerOrder": 'Ordine',
            "idCustomer": 'Cliente',
            "paymentDate": 'Data pagamento',
            "totalPayment": 'Importo versato',
            "methodPayment": 'Modalità di pagamento',
            "files": 'File',
            "notes": 'Note',
            "status": 'Stato',
            "status.options.0_PENDING": 'In attesa',
            "status.options.5_GENERATE": 'Generato',
            "status.options.10_PAID": 'Pagato',
            "progressivo": 'Progressivo',
            "vat": 'Aliquota',
            "description": 'Descrizione',

        },
        "customer_order_payment_file": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Nome',
            "file": 'File',
            "notes": 'Note'
        },
        "warehouse": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Nome'
        },
        "location": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idWarehouse": 'Magazzino',
            "name": 'Nome'
        },
        "customer_order_delivery": {
            "id": 'id',
            "date": 'Data creazione',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "author": 'ID Venditore',
            "idCustomerOrder": 'Ordine cliente',
            "internalCode": 'Codice interno',
            "deliveryDate": 'Data consegna prevista',
            "realDeliveryDate": 'Data consegna effettiva',
            "finishDeliveryDate": 'Data fine consegna effettiva',
            "idUserDelivery": 'Montatore',
            "notes": 'Note',
            "rows": 'Righe',
            "status": 'Stato',
            "status.options.0_PENDING": 'In attesa',
            "status.options.10_CREATED": 'Da consegnare',
            "status.options.20_DELIVERED": 'Consegnato',
            "files": 'File',
            "deliveryAddress": 'Indirizzo di consegna',
            "latitude": 'Latitudine',
            "longitude": 'Longitude',
            "locality": 'Città',
        },
        "customer_order_delivery_row": {
            "id": 'id',
            "date": 'Data creazione',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "author": 'Venditore',
            "idCustomerOrderDelivery": 'ID Consegna',
            "idCustomerOrderRow": 'ID Riga ordine',
            "name": 'Articolo',
            "description": 'Descrizione',
            "supplier": 'Fornitore',
            "quantity": 'Quantità',
            "notes": 'Note',
            "status": 'Stato',
            "status.options.0_PENDING": 'In attesa',
            "status.options.10_DELIVERED": 'Consegnato',
        },
        "gyv_customer_order_delivery": {
            "id": 'id',
            "date": 'Data creazione',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "author": 'ID Venditore',
            "idCustomerOrder": 'Ordine cliente',
            "internalCode": 'Codice interno',
            "deliveryDate": 'Data consegna prevista',
            "realDeliveryDate": 'Data consegna effettiva',
            "finishDeliveryDate": 'Data fine consegna effettiva',
            "idUserDelivery": 'Montatore',
            "notes": 'Note',
            "rows": 'Righe',
            "status": 'Stato',
            "status.options.0_PENDING": 'In attesa',
            "status.options.10_CREATED": 'Da consegnare',
            "status.options.20_DELIVERED": 'Consegnato',
            "files": 'File',
            "deliveryAddress": 'Indirizzo di consegna',
            "latitude": 'Latitudine',
            "longitude": 'Longitude',
            "locality": 'Città',
            "late": 'Stato consegna',
            "late.options.NO": 'In orario',
            "late.options.SI": 'In ritardo',
            "authorName": 'Venditore',
            "customer": 'Cliente',
        },
        "invoice": {
            "id": 'id',
            "date": 'Data creazione',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idCustomerOrder": 'Ordine cliente',
            "progressivo": 'Progressivo',
            "invoiceDate": 'Data fattura',
            "invoiceImponibile": 'Totale imponibile',
            "invoiceIva": 'Totale IVA',
            "invoiceTotal": 'Totale fattura',
            "status": 'Stato',
            "status.options.0_PENDING": 'In attesa',
            "status.options.10_CONFIRMED": 'Confermata',
            "xml": 'XML',
            "notes": 'Note',
            "rows": 'Righe',
            "idVatCondition": 'Condizione IVA',
        },
        "invoice_row": {
            "id": 'id',
            "date": 'Data creazione',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idCustomerOrderRow": 'Riga ordine cliente',
            "name": 'Nome',
            "description": 'Descrizione',
            "quantity": 'Quantità',
            "listPrice": 'Prezzo unitario',
            "discount": 'Sconto',
            "vat": 'IVA',
            "vatPrice": 'Prezzo IVA',
            "price": 'Prezzo imponibile',
            "totalPrice": 'Prezzo totale',
            "notes": 'Note',
        },
        "gyv_invoice": {
            "id": 'id',
            "date": 'Data creazione',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idCustomerOrder": 'Ordine cliente',
            "progressivo": 'Progressivo',
            "invoiceDate": 'Data fattura',
            "invoiceImponibile": 'Totale imponibile',
            "invoiceIva": 'Totale IVA',
            "invoiceTotal": 'Totale fattura',
            "status": 'Stato',
            "status.options.0_PENDING": 'In attesa',
            "status.options.10_CONFIRMED": 'Confermata',
            "xml": 'XML',
            "notes": 'Note',
            "rows": 'Righe',
            "customer": 'Cliente',
        },
        "method_payment": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Nome',
            "notes": 'Note'
        },
        "vat_condition": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Nome',
            "description": 'Descrizione',
            "percentage": 'Percentuale IVA',
            "natura": 'Natura',
            "defaultVat": 'Default',
            "notes": 'Note'
        },
        "customer_order_installment": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idCustomerOrder": 'Ordine',
            "cost": 'Importo',
            "dateInstallment": 'Data scadenza',
            "idMethodPayment": 'Modalità di pagamento',
            "notes": 'Note',
        }
    },

};
